import axios from './axios';

const loadSupportContacts = () =>
  axios({
    method: 'get',
    url: '/v1/support/contact'
  });

export { loadSupportContacts };
